import type { ComboboxOption } from "./types";

export interface ComboboxOptionsPage<T = string> {
  options: ComboboxOption<T>[];
  hasMore: boolean;
}

/** A bare array is a single page with no more results, so existing array-returning `getOptions` keep working unchanged */
export type ComboboxOptionsResult<T = string> =
  | ComboboxOption<T>[]
  | ComboboxOptionsPage<T>;

export const toOptionsPage = <T>(
  result: ComboboxOptionsResult<T>,
): ComboboxOptionsPage<T> =>
  Array.isArray(result) ? { options: result, hasMore: false } : result;

/** Appends a newly-fetched page, dropping any value already present on an earlier page. */
export const mergeOptionPages = <T>(
  existing: ComboboxOption<T>[],
  incoming: ComboboxOption<T>[],
): ComboboxOption<T>[] => {
  const seen = new Set(existing.map((option) => String(option.value)));
  const deduped = incoming.filter((option) => !seen.has(String(option.value)));
  return [...existing, ...deduped];
};
